import { Injectable } from '@angular/core';
import { Observable, Subject, ReplaySubject, catchError, map, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { CommonIndicator } from '@solvace/core/models';
import { AppEnvironmentConfig } from 'projects/config/model/environment.config.model';
import { SvcHttpClient } from 'projects/lib-shared-common/src/public-api';
import { DefectTagIndicator } from './models/defecttag-indicator';
import { DefectTagCategorizedDrillDown } from './models/defecttag-drilldown';
import { TasksCategory } from 'projects/lib-shared-core/src/lib/features/main-tasks/models/tasks-category';

@Injectable({ providedIn: 'root' })
export class DefecttagAnalyticsService extends SvcHttpClient {
  private _indicator: ReplaySubject<DefectTagIndicator> = new ReplaySubject<DefectTagIndicator>();
  private _subordinatesIndicator: Subject<DefectTagIndicator> = new Subject<DefectTagIndicator>();
  private _categorizedDrillDown: Subject<DefectTagCategorizedDrillDown[]> = new Subject<DefectTagCategorizedDrillDown[]>();

  public _indicator$: ReplaySubject<DefectTagIndicator> = this._indicator;
  public _subordinatesIndicator$: Observable<DefectTagIndicator> = this._subordinatesIndicator.asObservable();
  public _categorizedDrillDown$: Observable<DefectTagCategorizedDrillDown[]> = this._categorizedDrillDown.asObservable();

  constructor(appConfig: AppEnvironmentConfig, httpClient: HttpClient) {
    super(appConfig.APIs.apiUrlDefectTag, httpClient);
  }

  getDefectTagIndicators(): Observable<DefectTagIndicator> {
    this._indicator.next(null);
    return this.get<CommonIndicator>('/Counters/defecttag').pipe(
      map((response: CommonIndicator) => new DefectTagIndicator(response)),
      tap((indicator) => {
        this._indicator.next(indicator);
      }),
      catchError((error) => {
        this._indicator.next(new DefectTagIndicator({ hasError: true }));
        return throwError(() => error);
      })
    );
  }

  getDefectTagSubordinatesIndicators(): Observable<DefectTagIndicator> {
    this._indicator.next(null);
    return this.get<CommonIndicator>('/Counters/defecttag/subordinates').pipe(
      map((response: CommonIndicator) => new DefectTagIndicator(response)),
      tap((indicator) => {
        this._subordinatesIndicator.next(indicator);
      }),
      catchError((error) => {
        this._indicator.next(new DefectTagIndicator({ hasError: true }));
        return throwError(() => error);
      })
    );
  }

  getDefectTagCategorizedDrillDown(type: TasksCategory): Observable<DefectTagCategorizedDrillDown[]> {
    return this.get<DefectTagCategorizedDrillDown[]>(`/Analytics/defecttag/details/type?indicadorTypeDetail=${type}`).pipe(
      map((response: DefectTagCategorizedDrillDown[]) =>
        response.map((r) => {
          return {
            ...r,
            indicatorItems: r.indicatorItems.map((i) => ({
              ...i,
              owners: [i['owner']],
            })),
          };
        })
      ),
      tap((indicator) => {
        this._categorizedDrillDown.next(indicator);
      })
    );
  }

  getDefectTagCategorizedDrillDownSubordinates(type: TasksCategory): Observable<DefectTagCategorizedDrillDown[]> {
    return this.get<DefectTagCategorizedDrillDown[]>(`/Analytics/defecttag/subordinates/details/type?indicadorTypeDetail=${type}`).pipe(
      map((response: DefectTagCategorizedDrillDown[]) =>
        response.map((r) => {
          return {
            ...r,
            indicatorItems: r.indicatorItems.map((i) => ({
              ...i,
              owners: [i['owner']],
            })),
          };
        })
      ),
      tap((indicator) => {
        this._categorizedDrillDown.next(indicator);
      })
    );
  }
}
